// ESGine API utility
// All API calls go through this file

const API_BASE = 'https://api.esgine.io';
const ORIGIN = 'https://esgine.io';

// Get token from session storage
export const getToken = () => sessionStorage.getItem('esgine_token');

// Get user from session storage
export const getUser = () => {
  const u = sessionStorage.getItem('esgine_user');
  return u ? JSON.parse(u) : null;
};

// Check if logged in
export const isAuthenticated = () => !!getToken();

// Clear session
export const logout = () => {
  sessionStorage.removeItem('esgine_token');
  sessionStorage.removeItem('esgine_user');
};

// Base fetch with auth headers
const apiFetch = async (path, options = {}) => {
  const token = getToken();
  const headers = {
    'Content-Type': 'application/json',
    'Origin': ORIGIN,
    ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
    ...(options.headers || {}),
  };

  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.error || `API error ${res.status}`);
  }

  return data;
};

// Auth
export const login = async (email, password) => {
  const data = await apiFetch('/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email: email.trim().toLowerCase(), password }),
  });
  // Store token and user
  sessionStorage.setItem('esgine_token', data.token);
  sessionStorage.setItem('esgine_user', JSON.stringify(data.user));
  return data;
};

// Frameworks
export const getFrameworks = async () => {
  const data = await apiFetch('/frameworks');
  return data.frameworks || [];
};

// Run check history
export const getHistory = async () => {
  const data = await apiFetch('/run-check/history');
  return data.checks || [];
};

// Upload document and run check
export const runCheck = async (file, frameworkCode, entityName, entitySize, scopes) => {
  const token = getToken();
  const formData = new FormData();
  formData.append('file', file);
  formData.append('framework_code', frameworkCode);
  formData.append('entity_name', entityName);
  formData.append('entity_size', entitySize || 'medium');
  if (scopes) formData.append('scopes', JSON.stringify(scopes));

  const res = await fetch(`${API_BASE}/run-check/upload`, {
    method: 'POST',
    headers: {
      'Origin': ORIGIN,
      'Authorization': `Bearer ${token}`,
    },
    body: formData,
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Check failed');
  return data;
};

// Get check status
export const getCheckStatus = async (checkId) => {
  return await apiFetch(`/run-check/status?check_id=${checkId}`);
};
